import { ResolvedComponentsConfiguration } from "@zoovu/runner-browser-api";
import globals from "./global-variables";
import stylesConfig from "../styles.config";
import mediaQuery from "../abstract/media-query";

export default {
  "& .answer-info-text-trigger": {
    display: "inline-block",
    width: "20px",
    height: "20px",
    paddingBottom: "15px",
    "min-width": "20px",
    "min-height": "20px",
    "line-height": "20px",
    "text-align": "center",
    "font-style": "normal",
    "margin-left": "auto",
    cursor: "pointer",
    zIndex: 1,
    borderRadius: "50%",
    backgroundImage: (configuration: ResolvedComponentsConfiguration): string =>
      `${globals.customerSpriteTheme5(configuration)}`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "0px 0px",
    backgroundColor: stylesConfig.colors.secondary.spectrum500,
    "&:focus": {
      outlineColor: stylesConfig.colors.primary.spectrum400,
    },
    [mediaQuery.hover]: {
      "&:hover": {
        backgroundPosition: "-25px 0px",
        backgroundColor: stylesConfig.colors.primary.spectrum400,
      },
    },
    [`@media (${globals.breakpoints.$xs})`]: {
      "&:after": {
        content: "' '",
        width: "40px",
        height: "40px",
        marginLeft: "-10px",
        marginTop: "-10px",
        display: "block",
      },
    },
    "&.top-right": {
      position: "absolute",
      right: "8px",
      top: "8px",
    },
  },
};
